import { Result } from 'antd';

/**
 * 403页面
 */
function Forbidden() {
  return <Result status="403" title="403" subTitle="抱歉，你无权访问该页面" />;
}

export default Forbidden;
